<!-- TEMPLATE -->
<template>
    <div>
        <v-toolbar class="primary" dense :tabs="groupedData.length > 0" dark fixed app>
            <slot name="toolbar-icon"></slot>
            <v-toolbar-title>Last Games</v-toolbar-title>
            <slot name="toolbar-links"></slot>
            <v-tabs @change="changeAnchor" v-show="groupedData.length" color="primary" slot="extension" v-model="activeRegion" show-arrows>
                <v-tab v-for="(region) in groupedData" :key="region.name">
                    <b>{{regionNames[region.name]}}</b>
                </v-tab>
            </v-tabs>
        </v-toolbar>
        <!-- <v-spacer></v-spacer> -->
        <v-content>
            <v-container>
                <v-layout class="global-loader" v-if="!groupedData.length" justify-center>
                    <v-progress-circular :width="3" indeterminate color="primary"></v-progress-circular>
                </v-layout>
                <v-layout justify-center column v-if="groupedData.length">
                    <v-tabs-items touchless v-model="activeRegion">
                        <v-tab-item v-for="(region) in groupedData" :key="region.name">
                            <v-layout justify-center>
                                <v-flex class="block-container" xs12 lg9>
                                    <v-flex class="block-title subheading" xs12>
                                        Players Stats
                                    </v-flex>
                                    <v-flex class="block-elem" xs12>
                                        <PlayersStats :players="mapPlayersStats(region.playersStats)" />
                                    </v-flex>
                                    <v-flex class="block-title subheading" xs12>
                                        Games
                                    </v-flex>
                                    <v-flex class="block-elem" xs12>
                                        <DraftsList :drafts="region.drafts" :title="region.name" />
                                    </v-flex>
                                </v-flex>
                                <!-- <v-flex>
    <div :id="'twitter-timeline-' + region.name"></div>
</v-flex> -->
                            </v-layout>
                        </v-tab-item>
                    </v-tabs-items>
                </v-layout>
            </v-container>
        </v-content>
    </div>
</template>
<!-- SCRIPT -->
<script>
// import champions from "../../assets/data/champions.json"
// import moment from "moment"
import { map } from "lodash"

import db from "../modules/db"
import DraftsList from "./Drafts/DraftsList.vue"
import PlayersStats from "./Stats/PlayersStats.vue"

const REGIONS = ['LEC', 'LCK', 'LCS'];

export default {
    name: 'Region',
    components: {
        DraftsList,
        PlayersStats
    },
    created: function() {
        this.fetchData(this.$route);
    },
    data: function() {
        let hashIndex = REGIONS.indexOf(this.$route.hash.replace('#', ''));

        return {
            activeRegion: hashIndex >= 0 ? hashIndex : 0,
            regionKey: 'LEC',
            groupedData: [],
            regionNames: {
                EU: 'LEC',
                NA: 'LCS',
                LCK: 'LCK'
            }
        }
    },
    methods: {
        fetchData: async function() {
            this.groupedData = await db.getNews();
        },
        mapPlayersStats: function(playersStats) {
            return map(playersStats, (player, playerName) => {
                player.name = playerName;
                return player;
            });
        },
        changeAnchor: function(tabInput) {
            this.$router.push('#' + REGIONS[tabInput]);
        }
    }
}
</script>
<!-- STYLE -->
<style scoped>
.global-loader {
    min-height: 100vh;
}

img.filter-grey {
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
}

.block-title {
    /*margin-bottom: 10px;*/
    color: grey;
}

.block-elem {
    margin-bottom: 10px;
}

.block-container {
    /*margin-top: 10px;*/
}
</style>